var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isFeatureEnabled)?_vm._t("default",null,null,_vm.slotProps):_vm._t("fallback")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }